
import { Component, Vue } from "vue-property-decorator";
import { TNote, TNote_Table } from "@/models/case_notes";
import { API_ROUTES } from "@/utils/API";
import CommentNote from "./components/CommentNote.vue";
import vueEditorOptions from "@/plugins/vue-editor/options-default";

import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import { SMActivityLog } from "@/store";

const NOTE_COMMENT_TYPE = "comment";
const ACTIVE_CLASS = "active";

const ICONS = {
  send: "send",
};

@Component({
  components: {
    CommentNote,
  },
})
export default class VExpertTemplateActivityLog extends Vue {
  get notes(): TNote_Table[] {
    return SMActivityLog.notes;
  }

  icons = ICONS;

  warningType = WARNING_POPUP_TYPE;

  message = "";
  editedIndex = 0;

  editorOptions = vueEditorOptions.editorSettingsNoHeader;
  customModulesForEditor = vueEditorOptions.customModulesForEditor;

  isSendIconVisible = false;

  deletePopup = {
    isOpen: false,
    id: 0,
  };

  closeDeletePopup() {
    this.deletePopup.isOpen = false;
  }

  get showSendIcon() {
    return this.isSendIconVisible || this.message;
  }

  get classes() {
    return { [`${ACTIVE_CLASS}`]: this.isSendIconVisible };
  }

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  atFocusInput() {
    this.isSendIconVisible = true;
  }

  atBlurInput() {
    this.isSendIconVisible = false;
  }

  beforeDestroy() {
    this.atBlurInput();
  }

  async leaveMessage() {
    if (!this.message) return;

    const data: TNote = {
      message: this.message,
    };

    await this.axios.post(API_ROUTES.CASE_ACTIVITY_LOG(this.caseId), data);

    await SMActivityLog.fetchtNotes(this.caseId);

    this.message = "";
  }

  isComment(type: string) {
    return type === NOTE_COMMENT_TYPE;
  }

  editNote(id: number) {
    this.editedIndex = id;
  }

  finishEditingComment() {
    SMActivityLog.fetchtNotes(this.caseId);

    this.editedIndex = 0;
  }

  openDeletePopup(id: number) {
    this.deletePopup.isOpen = true;
    this.deletePopup.id = id;
  }

  async deleteNote(id: number) {
    await this.axios.delete(API_ROUTES.CASE_ACTIVITY_LOG_EDIT(this.caseId, id));

    await SMActivityLog.fetchtNotes(this.caseId);

    this.deletePopup.isOpen = false;
  }
}
